import React from 'react';

export default function LastSeenPixel() {
    return (
        <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
                __html: `(new Image()).src = "/profiles/api/update-last-seen-time";`,
            }}
        />
    );
}
